const ossBucket = {
  dev: 'cloud-clinic-dev',
  test: 'cloud-clinic-test',
  production: 'cloud-clinic-prod'
}

const scaleH5 = {
  dev: 'http://localhost:3000/',
  test: 'http://test.cloudclinic.ancare.net:89/',
  // production: 'http://test.cloudclinic.ancare.net:89/'
  // production: 'http://prev.cloudclinic.ancare.net:89/'
  production: 'http://cloudclinic.ancare.net:89/'
}

export default {
  OSSConfig: {
    region: 'oss-cn-shanghai',
    accessKeyId: 'LTAI5tAQtHbagpEA8WcVgcLA',
    accessKeySecret: 'I6EzQMnHuQz37r3HHBEcgL0VjW7ymQ',
    bucket: ossBucket[process.env.ENV],
  },
  sortField: {
    min: 0,
    max: 99999
  },
  scaleH5Url : scaleH5[process.env.ENV],
  storageKeys: {
    tokenKey: 'fulcrum-ancare-token',
    roleKey: 'fulcrum-ancare-token',
    formLayoutKey: 'fulcrum-ancare-formLayout',
  },
  formLayoutConfig: {
    compact: {
      colSpan: 6,
      showAnchr: false,
      rowGutter: 16,
      formSize: 'small',
      formItemLayout: {
        labelCol: {
          span: 8,
        },
        wrapperCol: {
          span: 16,
        },
      },
      familyItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 20,
        },
      },
      questionItemLayout: {
        labelCol: {
          span: 2,
        },
        wrapperCol: {
          span: 22,
        },
      },
    },
    loose: {
      colSpan: 12,
      showAnchr: true,
      rowGutter: 32,
      formSize: 'middle',
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      familyItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      questionItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 20,
        },
      },
    }
  }
}
